import React, { useContext, useEffect, useState } from "react";
import AppLayoutSecondaryHeader from "./layout/AppLayout/AppLayoutSecondaryHeader";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Alert,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SchoolIcon from "@mui/icons-material/School";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PsContext from "../context";
import { _DASHBOARD_FIRST_LINE_COUNT } from "../models/dashboardModel";
import ModuleAccess from "../context/moduleAccess";
import HandshakeIcon from "@mui/icons-material/Handshake";
import { SAAS_SITE_URL } from "../utils";

const WelcomePage = () => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [firstLineData, setFirstLineData] = useState([]);
  const [copySuccess, setCopySuccess] = useState(false);

  useEffect(() => {
    setLoader(true);
    _DASHBOARD_FIRST_LINE_COUNT().then((res) => {
      if (res.status === "1") setFirstLineData(res.data);
      setLoader(false);
    });
  }, []);

  // Set default domain name if not available
  //const domainName = context.userData.domain_name || "school.kalvisalai.in";
  const domainName = context.userData.domain_name
    ? `https://${context.userData.domain_name}/`
    : SAAS_SITE_URL;

  const referralLink = `${domainName}register/${context.userData.id}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    });
  };

  // Fixed Card Size Style
  const cardStyle = {
    textAlign: "center",
    color: "#fff",
    minWidth: "220px",
    height: "150px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <>
      <AppLayoutSecondaryHeader title="Dashboard" />
      <div className="container">
        {/* Add margin to push content below header */}
        <Grid
          container
          spacing={3}
          justifyContent="center"
          sx={{ marginTop: "80px" }}
        >
          {/* Welcome Card (Now properly positioned below header) */}
          <Grid item xs={12}>
            <Card
              sx={{ textAlign: "center", background: "#1976d2", color: "#fff" }}
            >
              <CardContent>
                <Typography variant="h5">
                  Hello, {context.userData.emp_name}
                </Typography>
                <Typography variant="h4" fontWeight="bold">
                  Welcome to Kalvisalai
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Dashboard Grid Boxes */}
          <Grid item xs={12} sm={6} md={3}>
            <Link to="/app/profile-card" style={{ textDecoration: "none" }}>
              <Card sx={{ ...cardStyle, background: "#ff9800" }}>
                <PersonIcon sx={{ fontSize: 40 }} />
                <Typography variant="h6">My Profile</Typography>
              </Card>
            </Link>
          </Grid>

          <ModuleAccess module="reseller_setup" action="action_list">
            <Grid item xs={12} sm={6} md={3}>
              <Link to="/app/reseller-setup" style={{ textDecoration: "none" }}>
                <Card sx={{ ...cardStyle, background: "#9c27b0" }}>
                  <HandshakeIcon sx={{ fontSize: 40 }} />
                  <Typography variant="h6">Reseller Setup</Typography>
                </Card>
              </Link>
            </Grid>
          </ModuleAccess>

          <Grid item xs={12} sm={6} md={3}>
            <Link to="/app/schools" style={{ textDecoration: "none" }}>
              <Card sx={{ ...cardStyle, background: "#4caf50" }}>
                <SchoolIcon sx={{ fontSize: 40 }} />
                <Typography variant="h6">Total Schools</Typography>
                <Typography variant="h5" fontWeight="bold">
                  {loader ? ".." : firstLineData.schools || "0"}
                </Typography>
              </Card>
            </Link>
          </Grid>
          <ModuleAccess module="user_logins" action="action_list">
            <Grid item xs={12} sm={6} md={3}>
              <Link
                to="/app/settings/user-logins"
                style={{ textDecoration: "none" }}
              >
                <Card sx={{ ...cardStyle, background: "#f44336" }}>
                  <AssignmentIndIcon sx={{ fontSize: 40 }} />
                  <Typography variant="h6">Users</Typography>
                </Card>
              </Link>
            </Grid>
          </ModuleAccess>

          {/*  <Grid item xs={12} sm={6} md={3}>
            <Link to="/app/members" style={{ textDecoration: "none" }}>
              <Card sx={{ ...cardStyle, background: "#9c27b0" }}>
                <GroupsIcon sx={{ fontSize: 40 }} />
                <Typography variant="h6">Members</Typography>
              </Card>
            </Link>
          </Grid> */}

          {/* Referral Link Section */}
          <Grid item xs={12}>
            <Card sx={{ textAlign: "center" }}>
              <CardContent>
                <Typography variant="h6">My Referral Link</Typography>
                <Alert
                  severity="info"
                  action={
                    <Button
                      color="inherit"
                      size="small"
                      onClick={copyToClipboard}
                      startIcon={<ContentCopyIcon />}
                    >
                      {copySuccess ? "Copied!" : "Copy Link"}
                    </Button>
                  }
                >
                  {referralLink}
                </Alert>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default WelcomePage;
